// eslint-disable-next-line import/prefer-default-export
export const getUrlWithTrailingSlash = (url) => {
    if (!url) return "";

    const [pathAndQuery, hash] = url.split("#");
    const [path, query] = pathAndQuery.split("?");

    if (/\.[a-zA-Z0-9]+$/.test(path) || path.endsWith("/")) {
        return url;
    }

    const result = `${path}/`;
    const withQuery = query ? `${result}?${query}` : result;
    return hash ? `${withQuery}#${hash}` : withQuery;
};
